import React from "react";
import "./assets/css/App.css";
import WhatsAppButton from "./components/WhatsAppButton";
import Banner from "./components/Banner";
import FAQ from "./components/Faq";
import FeatureSection from "./components/FeatureSection";
import SloganRow from "./components/SloganRow";
import HeroBanner from "./components/HeroBanner";
import ProductList from "./components/ProductCard";
import SecureDataSection from "./components/SecureDataSection";

import ProductGrid from "./components/ProductGrid";
import PromoSection from "./components/PromoSection";
import ProductCategoryV2 from "./components/ProductCategoryV2";
import CommunitySection from "./components/CommunitySection";
import CommunitySection1 from "./components/CommunitySection1";

function HomeYeni() {
  return (
    <div className="bg-gray-50">
      <Banner />
      <SloganRow />
      <HeroBanner />
      <ProductGrid />
      <ProductCategoryV2 />
      <SecureDataSection />
      <PromoSection />
      <CommunitySection />
      <CommunitySection1 />
      <FeatureSection />
      <FAQ />
    </div>
  );
}

export default HomeYeni;
